<template>
  <div class="header">
    <div class="head-title more-text1 text-overflow-ellipsis-2 font-semibold-new" :class="{'bigTitle1': isBigTitle, 'is-hk-font': isHK}">
      {{ columnTitle }}
    </div>
    <DiffLinkLabel v-if="moreName" class="head-more" :url="moreUrl" :target="target">
      <div class="head-more" @click="moreClick">
        <div class="more-text2 text-overflow-ellipsis" :class="{'bigTitle1': isBigTitle}">
          {{ moreName }}
        </div>
        <div class="iconfont icon-more-right2" />
      </div>
    </DiffLinkLabel>
  </div>
</template>

<script>
/**
 *  模块头部
 */
import mixin from './mixin';
import DiffLinkLabel from '../DiffLinkLabel/web.vue'

export default {
  components: {
    DiffLinkLabel,
  },
  mixins: [mixin],
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  .more-text1 {
    max-width: 220px;
  }

  .more-text2 {
    max-width: 150px;
  }

  .bigTitle1 {
    max-width: 600px;
  }

  .head-title {
    font-size: 24px;
    font-family: Roboto-Flex, sans-serif;
    color: var(--txt-color-lv4);
    cursor: default;

    &.is-hk-font {
      font-size: 18px;
    }
  }

  .head-more {
    display: flex;
    align-items: center;
    font-size: 22px;
    font-family: Roboto-Flex, sans-serif;
    font-weight: 600;
    color: var(--txt-color-link5);
    cursor: pointer;

    .icon-more-right2 {
      margin-top: 3px;
      font-size: 24px;
      color: var(--txt-color-link5);
      transform: scale(0.6);
    }
  }
}
</style>
